import React, { useEffect, useState } from "react"
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { Faders, Minus, Plus, X } from '@phosphor-icons/react'
import CheckBox from '@components/common/CheckBox'
import ColorPanel from '@components/Products/common/ColorPanel'
import { MockPrintedPalettes } from '@mockdata/mockdata'
import StarRating from '@components/common/StarRating'
import {
  coverageBottomOptions,
  coverageTopOptions,
  printedOptions,
  sizeOptions,
  texturedOptions,
  ratingOptions,
} from "@components/helpers/SizeAndMetrics"
import RadioGroupList from "@components/common/RadioGroupList"

const FilterList = ({getFilters, hideHeaders = false, ...props}) => {
  const [filters, setFilters] = useState([])
  const [filterCount, setFilterCount] = useState(0)

  const handleFilterChange = (category, option, isChecked) => {
    setFilters((prev) => {
      const previousVal = { ...prev };
      let currentCategory = previousVal[category] ?? [];
  
      if (category === "sortBy") {
        // For sortBy, simply replace the current value
        previousVal["sortBy"] = option;
      } else if (category === "colour") {
        // For colour, replace the entire current value with the new option if checked
        option["isChecked"] = true;
        previousVal["colour"] = isChecked ? [option] : [];
      } else if (isChecked) {
        // Add option if checked
        option["isChecked"] = true;
        currentCategory.push(option);
        previousVal[category] = currentCategory;
      } else {
        // Remove option if unchecked
        currentCategory = currentCategory.filter((item) => item.id !== option.id);
        previousVal[category] = currentCategory;
      }
  
      return previousVal;
    });
  };

  const handleSortChange = (selected) => {
    // console.log("opt selected:",selected)
    handleFilterChange("sortBy", selected)
  }
  
  // const handleApplyAllFilters = () => {
  //   const applyIsChecked = (group) => {
  //     const newGroup = group.map(item => {
  //       return {...item, isChecked: true}
  //     })

  //     return newGroup
  //   }

  //   setFilters(() => {
  //     const appliedFilters = {
  //       bottoms: applyIsChecked(coverageBottomOptions),
  //       printed: applyIsChecked(printedOptions),
  //       ratings: applyIsChecked(ratingOptions),
  //       size: applyIsChecked(sizeOptions),
  //       textured: applyIsChecked(texturedOptions),
  //       tops: applyIsChecked(coverageTopOptions),
  //     }

  //     return appliedFilters
  //   })
  // }

  const handleApplyFilters = () => {
    // TO-DO: call api to apply filters here
  }

  useEffect(() => {
    if(getFilters) getFilters(filters)
    let count = 0
    Object.values(filters).map((opts) => {
      if(!opts.length) count += 1
      else if(opts) {
        count += opts.length
      } 
    })

    setFilterCount(count)
  }, [filters])

  useEffect(() => {
    handleFilterChange("sortBy", { id: "sortId_0", label: "Featured" })
  }, [])

  return (
    <React.Fragment>
      <div {...props}>
        <div className="flex flex-nowrap justify-between p-4">
          {!hideHeaders && (
            <div className="flex flex-nowrap justify-between bg-white items-center flex-1 border-b border-b-gray-300 pb-6">
              <p className=" text-gray-500 w-full flex flex-nowrap gap-x-1">
                FILTERS & SORT
                <span className={`${filters && Object.keys(filters).length > 1 ? 'block' : 'hidden'}`}>{`(${filterCount})`}</span>
              </p>
              <div className="hidden xl:block relative">
                <Faders size={20} weight="light" />
                {filters && Object.keys(filters).length > 1 && (
                  <div
                    className={`absolute size-2 bg-red-600 bottom-0 right-0 rounded-full mb-1.5`}
                  />
                )}
              </div>
            </div>
          )}
          <X
            className="block xl:hidden cursor-pointer text-black"
            size={20}
            weight="light"
            onClick={() => {
              if(props.onClose) props.onClose()
            }}
          />
        </div>

        <section className={`w-full max-w-none md:max-w-64 px-4 pb-4 h-[calc(100vh_-_50px)] xl:h-full overflow-y-scroll xl:overflow-y-auto scrollbar-hide`}>
          <div className="py-4 space-y-4">
            {/* SORT BY */}
            <Disclosure defaultOpen={true}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={"group flex flex-nowrap w-full items-center"}
                  >
                    <div className="inline-flex flex-1 items-center gap-x-2">
                      <span className="accordion-button">Sort By</span>
                      {filters && filters["sortBy"] && (
                        <span className="rounded-full py-1 px-1.5 border text-xxs border-gray-400 leading-none min-w-5">
                          1
                        </span>
                      )}
                    </div>
                    {open ? (
                      <Minus size={16} weight="light" />
                    ) : (
                      <Plus size={16} weight="light" />
                    )}
                  </DisclosureButton>
                  <DisclosurePanel
                    transition
                    className="mt-6 origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 text-[#3D3D3D]"
                  >
                    <div className="px-2">
                      <RadioGroupList
                        options={[
                          { id: "sortId_0", label: "Featured", value: 'featured' },
                          { id: "sortId_1", label: "Best Selling" , value: 'filter_bestseller' },
                          { id: "sortId_2", label: "Alphabetically, A-Z" , value: 'filter_a_z' },
                          { id: "sortId_3", label: "Alphabetically, Z-A" , value: 'filter_z_a' },
                          { id: "sortId_4", label: "Price, Low to High" , value: 'filter_high' },
                          { id: "sortId_5", label: "Price, High to Low" , value: 'filter_low' },
                        ]}
                        className='space-y-3'
                        onChange={(selected) => handleSortChange(selected)}
                        ariaLabel="filter-sort-by"
                      />
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
            {/*  */}

            {/* SIZE */}
            <Disclosure defaultOpen={true}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={"group flex flex-nowrap w-full items-center"}
                  >
                    <div className="inline-flex flex-1 items-center gap-x-2">
                      <span className="accordion-button">Size</span>
                      {filters && filters["size"]?.length > 0 && (
                        <span className="rounded-full py-1 px-1.5 border text-xxs border-gray-400 leading-none min-w-5">
                          {filters["size"]?.length}
                        </span>
                      )}
                    </div>
                    {open ? (
                      <Minus size={16} weight="light" />
                    ) : (
                      <Plus size={16} weight="light" />
                    )}
                  </DisclosureButton>
                  <DisclosurePanel
                    transition
                    className="mt-6 origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 text-[#3D3D3D]"
                  >
                    <div className="px-2">
                      <ul className="list-none">
                        {sizeOptions.map((item) => (
                          <CheckBox
                            groupLabel="filter-size"
                            className="py-2"
                            labelSpacing="space-x-4"
                            key={`size-${item.id}`}
                            label={item.label}
                            onChange={(isChecked) =>
                              handleFilterChange("size", item, isChecked)
                            }
                            checked={filters["size"]?.find(current => current.id === item.id ) ?? false}
                          />
                        ))}
                      </ul>
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
            {/*  */}

            {/* TOPS AND BOTTOMS */}
            <Disclosure defaultOpen={true}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={"group flex flex-nowrap w-full items-center"}
                  >
                    <div className="inline-flex flex-1 items-center gap-x-2">
                      <span className="accordion-button">Coverage</span>
                      {filters && (filters["tops"]?.length > 0 ||
                        filters["bottoms"]?.length > 0) && (
                        <span className="rounded-full py-1 px-1.5 border text-xxs border-gray-400 leading-none min-w-5">
                          {(filters["tops"]?.length ?? 0) +
                            (filters["bottoms"]?.length ?? 0)}
                        </span>
                      )}
                    </div>
                    {open ? (
                      <Minus size={16} weight="light" />
                    ) : (
                      <Plus size={16} weight="light" />
                    )}
                  </DisclosureButton>
                  <DisclosurePanel
                    transition
                    className="mt-6 origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 text-[#3D3D3D]"
                  >
                    <div className="px-2">
                      <h6 className="pb-3">Tops</h6>
                      <ul className="list-none">
                        {coverageTopOptions.map((item) => (
                          <CheckBox
                            groupLabel="filter-coverage-tops"
                            className="py-2"
                            labelSpacing="space-x-4"
                            key={`coverage-${item.id}`}
                            label={item.label}
                            onChange={(isChecked) =>
                              handleFilterChange("tops", item, isChecked)
                            }
                            checked={filters["tops"]?.find(current => current.id === item.id ) ?? false}
                          />
                        ))}
                      </ul>

                      <h6 className="py-3">Bottoms</h6>
                      <ul className="list-none">
                        {coverageBottomOptions.map((item) => (
                          <CheckBox
                            groupLabel="filter-coverage-bottoms"
                            className="py-2"
                            labelSpacing="space-x-4"
                            key={`coverage-${item.id}`}
                            label={item.label}
                            onChange={(isChecked) =>
                              handleFilterChange("bottoms", item, isChecked)
                            }
                            checked={filters["bottoms"]?.find(current => current.id === item.id ) ?? false}
                          />
                        ))}
                      </ul>
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
            {/*  */}

            {/* COLORS */}
            <Disclosure defaultOpen={true}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={"group flex flex-nowrap w-full items-center"}
                  >
                    <div className="inline-flex flex-1 items-center gap-x-2">
                      <span className="accordion-button">Colors</span>
                      <span className="rounded-full py-1 px-1.5 border text-xxs border-gray-400 leading-none min-w-5">
                        1
                      </span>
                    </div>
                    {open ? (
                      <Minus size={16} weight="light" />
                    ) : (
                      <Plus size={16} weight="light" />
                    )}
                  </DisclosureButton>
                  <DisclosurePanel
                    transition
                    className="mt-6 origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 text-[#3D3D3D]"
                  >
                    <div className="px-2">
                      <ColorPanel
                        data={MockPrintedPalettes}
                        wrapFirstRow={true}
                        multiSelect={true}
                        handleFilterChange={handleFilterChange}
                      />
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
            {/*  */}

            {/* PRINTED */}
            <Disclosure defaultOpen={true}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={"group flex flex-nowrap w-full items-center"}
                  >
                    <div className="inline-flex flex-1 items-center gap-x-2">
                      <span className="accordion-button">Printed</span>
                      {filters && filters["printed"]?.length > 0 && (
                        <span className="rounded-full py-1 px-1.5 border text-xxs border-gray-400 leading-none min-w-5">
                          {filters["printed"]?.length}
                        </span>
                      )}
                    </div>
                    {open ? (
                      <Minus size={16} weight="light" />
                    ) : (
                      <Plus size={16} weight="light" />
                    )}
                  </DisclosureButton>
                  <DisclosurePanel
                    transition
                    className="mt-6 origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 text-[#3D3D3D]"
                  >
                    <div className="px-2">
                      <ul className="list-none">
                        {printedOptions.map((item) => (
                          <CheckBox
                            groupLabel="filter-printed"
                            className="py-2"
                            labelSpacing="space-x-4"
                            key={`printed-${item.id}`}
                            label={item.label}
                            onChange={(isChecked) =>
                              handleFilterChange("printed", item, isChecked)
                            }
                            checked={filters["printed"]?.find(current => current.id === item.id ) ?? false}
                          />
                        ))}
                      </ul>
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
            {/*  */}

            {/* Textured */}
            <Disclosure defaultOpen={true}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={"group flex flex-nowrap w-full items-center"}
                  >
                    <div className="inline-flex flex-1 items-center gap-x-2">
                      <span className="accordion-button">Textured</span>
                      {filters && filters["textured"]?.length > 0 && (
                        <span className="rounded-full py-1 px-1.5 border text-xxs border-gray-400 leading-none min-w-5">
                          {filters["textured"]?.length}
                        </span>
                      )}
                    </div>
                    {open ? (
                      <Minus size={16} weight="light" />
                    ) : (
                      <Plus size={16} weight="light" />
                    )}
                  </DisclosureButton>
                  <DisclosurePanel
                    transition
                    className="mt-6 origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 text-[#3D3D3D]"
                  >
                    <div className="px-2">
                      <ul className="list-none">
                        {texturedOptions.map((item) => (
                          <CheckBox
                            groupLabel="filter-coverage-textured"
                            className="py-2"
                            labelSpacing="space-x-4"
                            key={`printed-${item.id}`}
                            label={item.label}
                            onChange={(isChecked) =>
                              handleFilterChange("textured", item, isChecked)
                            }
                            checked={filters["textured"]?.find(current => current.id === item.id ) ?? false}
                          />
                        ))}
                      </ul>
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
            {/*  */}

            {/* 
            <Disclosure defaultOpen={true}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={"group flex flex-nowrap w-full items-center"}
                  >
                    <div className="inline-flex flex-1 items-center gap-x-2">
                      <span className="accordion-button">Ratings</span>
                      {filters && filters["ratings"]?.length > 0 && (
                        <span className="rounded-full py-1 px-1.5 border text-xxs border-gray-400 leading-none min-w-5">
                          {filters["ratings"]?.length}
                        </span>
                      )}
                    </div>
                    {open ? (
                      <Minus size={16} weight="light" />
                    ) : (
                      <Plus size={16} weight="light" />
                    )}
                  </DisclosureButton>
                  <DisclosurePanel
                    transition
                    className="mt-6 origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 text-[#3D3D3D]"
                  >
                    <div className="px-2 flex flex-col-reverse">
                      {ratingOptions.map((item, index) => (
                        <CheckBox
                          className="py-2"
                          labelSpacing="space-x-4"
                          key={`stars-${index}`}
                          label={
                            <StarRating
                              totalStars={index + 1}
                              initalRating={index + 1}
                              readOnly
                            />
                          }
                          onChange={(isChecked) =>
                            handleFilterChange("ratings", item , isChecked)
                          }
                          checked={filters["ratings"]?.find(current => current.id === item.id ) ?? false}
                        />
                      ))}
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
             */}
          </div>
          <div className="space-y-3 pb-10 xl:pb-0 sticky xl:relative w-full bottom-0 bg-white">
            <button className="btn-primary w-full xl:hidden" onClick={() => handleApplyFilters()} aria-label="Apply Filters">
              APPLY FILTERS
            </button>
            <button
              className={`btn-outline w-full ${filters && Object.keys(filters).length > 1 ? 'block' : 'hidden'}`}
              onClick={() => setFilters({
                sortBy: filters.sortBy,
              })}
              aria-label="Clear All"
            >
              CLEAR ALL
            </button>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default FilterList
